export const config = {
    apiUrl: process.env.REACT_APP_API_URL || "https://blablachat-api-stage.hairun-technology.com"
}